import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {LimitAndOffset} from "@/components/table/subComponents/Paginator/Paginator.tsx";
import {Table} from "@/components/table/Table.tsx";
import {shortDateTimeUser} from "@/lib/format.tsx";
import {AuditLog} from "@/lib/types/auditlogs.ts";
import {AuditLogActions} from "@/pages/auditlog/list/components/AuditLogActions.tsx";

type AuditLogsTable = {
  items: AuditLog[];
  pagination?: LimitAndOffset;
  totalRows?: number;
  updatePagination?: (laf: LimitAndOffset) => void;
};

export const AuditLogsTable = ({items, pagination, totalRows, updatePagination}: AuditLogsTable) => {
  const {user} = useCurrentUserContext();
  return (
    <Table
      rows={items}
      minWidth="800px"
      specs={[
        {
          fieldName: "created_at",
          accessor: (obj) => shortDateTimeUser(obj.created_at, user!),
          fieldTitle: "Date",
        },
        {
          fieldName: "user_display",
          accessor: (obj) => obj.user_display,
          fieldTitle: "User",
        },
        {
          fieldName: "model_display",
          accessor: (obj) => obj.model_display,
          fieldTitle: "Object Type",
        },
        {
          fieldName: "object_str",
          accessor: (obj) => obj.object_str,
          fieldTitle: "Object",
        },
        {
          fieldName: "object_id",
          accessor: (obj) => obj.object_id,
          fieldTitle: "Object ID",
        },
        {
          fieldName: "comment",
          accessor: (obj) => obj.comment,
          fieldTitle: "Comment",
        },
        {
          fieldName: "quick_actions",
          accessor: (obj) => (
            <AuditLogActions
              id={obj.id}
              objectString={obj.object_str}
              changes={obj.changes_list}
              modelDisplay={obj.model_display}
            />
          ),
        },
      ]}
      initialState={{columnPinning: {right: ["quick_actions"]}}}
      pagination={pagination}
      totalRows={totalRows}
      updatePagination={updatePagination}
    />
  );
};
